import React from 'react';
import styled from 'styled-components';
import Typography from '../../atoms/Typography';
import ColorDot from './ColorDot';

const Divider = styled.div`
  border-bottom: var(--color-border-tertiary);
  margin-bottom: 4px;
`;

const SectionTitleDiv = styled.div`
  padding: 4px 12px;
`;

const SectionTitle = ({ title }: { title: string }) => {
  return (
    <SectionTitleDiv>
      <Typography.Body type={'Button Text'} color={'var(--color-text-muted)'}>
        {title}
      </Typography.Body>
    </SectionTitleDiv>
  );
};

const PortalOptionDiv = styled.div<{ isSelected: boolean }>`
  padding: 8px 12px;
  background-color: ${(props) =>
    props.isSelected ? 'var(--color-bg-tertiary)' : 'var(--color-bg-primary)'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  border-bottom: 1px solid var(--color-border-secondary);

  &:hover {
    background: var(--color-bg-muted);
  }
`;

const PortalList = styled.div`
  max-height: 250px;
  overflow-y: scroll;
`;

const CreatePortalDiv = styled.div`
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
    background-color: var(--color-border-secondary);
  }
`;

const PortalPickerStyles = {
  Divider,
  SectionTitle,
  PortalOptionDiv,
  ColorDot,
  CreatePortalDiv,
  PortalList,
};

export default PortalPickerStyles;
